import { render, staticRenderFns } from "./TrafficConfig.vue?vue&type=template&id=ef4fae5c&"
import script from "./TrafficConfig.vue?vue&type=script&lang=js&"
export * from "./TrafficConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports